import Link from '@mui/material/Link';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import {styles} from "../../config/config.theme";
import classes from "./ProjectLinks.module.css";


const ProjectLinks = (props) => {
  return (
    <List
      sx={{
        width: "auto",
        pt: 0,
      }}
    >
      {props.links?.map((link, index) => (
        <ListItem key={index} disableGutters sx={{ pt: "4px", pb: "4px" }}>
          <ListItemText
            primary={
              <Link
                sx={{ fontSize: "0.8rem"}}
                className={classes.primary}
                href={link.src}
                target="_blank"
                rel="noopener"
                color="inherit"
              >
                {link.title + " "}
                <i className="fas fa-external-link-alt"></i>
              </Link>
            }
            secondary={
              <Typography
                id="modal-modal-title"
                variant="p"
                component="h2"
                sx={{ fontSize: "0.7rem", color: props.style && props.style.linkSecondaryColor ? props.style.linkSecondaryColor : styles["text-tertiary"] }}
              >
                {link.description}
              </Typography>
            }
            sx={{mt: "3px", mb: "3px"}}
          />
        </ListItem>
      ))}
    </List>
  );
};

export default ProjectLinks;
